/**
 * Enumerates US Military State codes for APO/FPO addresses as
 * [USPS Postal Codes](https://pe.usps.com/text/pub28/28apb.htm).
 */
export enum USMilitaryState {
  /**
   * Represents **Armed Forces Americas (AA)** as a
   * [USPS Postal Code](https://pe.usps.com/text/pub28/28apb.htm).
   *
   * Used for military addresses in the Americas (except Canada).
   */
  AA = 'AA',

  /**
   * Represents **Armed Forces Europe/Middle East/Africa/Canada (AE)** as a
   * [USPS Postal Code](https://pe.usps.com/text/pub28/28apb.htm).
   *
   * Used for military addresses in Europe, Middle East, Africa, and Canada.
   */
  AE = 'AE',

  /**
   * Represents **Armed Forces Pacific (AP)** as a
   * [USPS Postal Code](https://pe.usps.com/text/pub28/28apb.htm).
   *
   * Used for military addresses in the Pacific.
   */
  AP = 'AP'
}
